import React from 'react';
import Inputs from 'components/inputs/inputs';

const styles = {
  holder: {
    position: 'relative',
    bottom: '0.6rem'
  },
  button: {
    margin: '0.2rem'
  }
};

export default function ChangeStatusButton(props) {
  if (props.status === 'punchIn') {
    return (
      <div style={styles.holder}>
        <Inputs.Button variant='app' style={styles.button} onClick={() => props.onChange('startBreak')} iconClass='icons8-dashboard' label='Start Break' />
        <Inputs.Button variant='app' style={styles.button} onClick={() => props.onChange('punchOut')} iconClass='icons8-dashboard' label='Punch Out' />
      </div>
    );
  }
  if (props.status === 'punchOut') {
    return (
      <div style={styles.holder}>
        <Inputs.Button variant='app' style={styles.button} onClick={() => props.onChange('punchIn')} iconClass='icons8-dashboard' label='Punch In' />
      </div>
    );
  }
  if (props.status === 'startBreak') {
    return (
      <div style={styles.holder}>
        <Inputs.Button variant='app' style={styles.button} onClick={() => props.onChange('punchIn')} iconClass='icons8-dashboard' label='End Break' />
        <Inputs.Button variant='app' style={styles.button} onClick={() => props.onChange('punchOut')} iconClass='icons8-dashboard' label='Punch Out' />
      </div>
    );
  }
  return null;
}
